import {Component} from '@angular/core';
import {BaseComponent} from '../_base.component';

/**
 * @ignore
 */
@Component({
  selector: 'uex-input-text',
  templateUrl: './text.component.html',
  host: {
    class: 'uex-input-text'
  }
})
export class InputTextComponent extends BaseComponent<string> {

  public inputType: 'password' | 'text' = 'password';

  public toggleTypeInputIfPasswordType() {
    this.inputType = this.inputType === 'text' ? 'password' : 'text';
  }
}
